import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import classNames from "classnames";
import { ChevronDownIcon } from "@jti/brand-icons/chevron-down";
import { UiMinusIcon } from "@jti/brand-icons/ui-minus";
import { UiPlusIcon } from "@jti/brand-icons/ui-plus";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { LinkBehaviour } from "../../../../components/LinkBehaviour";
import { useHeaderContext } from "../../context";
import { Button } from "../Button";
import { PointsDisplay } from "../PointsDisplay";
import styles from "./Navigation.module.scss";
export const Navigation = ({ navLinks, renderSubmenu }) => {
    const [openedIndex, setOpenedIndex] = useState(null);
    const { hoveredIndex, setHoveredIndex, isLoyaltyActive } = useHeaderContext();
    const handleClick = (index) => {
        setOpenedIndex((prevIndex) => (prevIndex === index ? null : index));
    };
    const handleMouseEnter = (index) => {
        setHoveredIndex(index);
    };
    const handleMouseLeave = () => {
        setHoveredIndex(null);
    };
    const dispatchGTMEvent = (title) => {
        dispatchTrackingEvent(TrackingEvents.TrackingMenuNavigationClick, { menu_link: title });
    };
    return (_jsx("nav", { className: styles.container, children: _jsx("ul", { className: styles.list, children: navLinks.map(({ title, url, secondaryNavigation, isActive, isLoyalty, loyaltyPointsCurrency }, index) => {
                const shouldRenderSecondaryNavigation = secondaryNavigation && ((isLoyalty && isLoyaltyActive) || !isLoyalty);
                return (_jsxs("li", { className: classNames({
                        [styles.listItemWrapperOpened]: openedIndex === index,
                    }), onMouseEnter: () => handleMouseEnter(index), onMouseLeave: handleMouseLeave, children: [_jsxs("div", { className: styles.listItem, children: [_jsx(Button, { asChild: true, children: _jsxs(LinkBehaviour, { href: url, className: classNames(styles.link, {
                                            [styles.linkWithSecondaryNavigation]: secondaryNavigation,
                                            [styles.active]: isActive,
                                        }), title: title, onClick: () => dispatchGTMEvent(title), children: [title, isLoyalty && _jsx(PointsDisplay, { loyaltyCurrency: loyaltyPointsCurrency }), shouldRenderSecondaryNavigation && (_jsx(ChevronDownIcon, { className: classNames(styles.iconSize, styles.chevron, {
                                                    [styles.isHovered]: hoveredIndex === index,
                                                }) }))] }) }), shouldRenderSecondaryNavigation && (_jsx("button", { type: "button", className: classNames(styles.buttonToggler, {
                                        [styles.buttonTogglerOpened]: openedIndex === index,
                                    }), onClick: () => handleClick(index), children: openedIndex === index ? (_jsx(UiMinusIcon, { className: styles.iconSize })) : (_jsx(UiPlusIcon, { className: styles.iconSize })) }))] }), shouldRenderSecondaryNavigation && (_jsx("div", { className: classNames(styles.submenu, {
                                [styles.isHovered]: hoveredIndex === index,
                                [styles.submenuOpened]: openedIndex === index,
                            }), children: renderSubmenu?.(secondaryNavigation.id) }))] }, `${title}-${url}`));
            }) }) }));
};
//# sourceMappingURL=Navigation.js.map